export enum MediaTypes {
	cfpublic = 'cfpublic',
	cf = 'cf',
	videoCf = 'video-cf',
	videoDefault = 'video-default', //(.mp4)
	videoDefaultPrivate = 'video-private', //private video from our backend (.mp4)
	videoPreviewCf = 'cfpublic-video-preview', //used only in pair with video-cf as preview
	default = 'default',
	defaultPrivate = 'default-private', //private image from our backend
}

export type CFImage = {
	reference: string;
	heightMax: number;
	widthMax: number;
};

export type TMediaCFPublicImage = {
	type: MediaTypes.cfpublic;
	reference: string;
};

export type TMediaCFImage = {
	type: MediaTypes.cf;
	previewLinks?: CFImage[];
	sizeLinks: CFImage[];
};

export type TMediaDefaultImage = {
	type: MediaTypes.default;
	reference: string;
};

export type TMediaCFVideoPreview = {
	reference: string;
	type: MediaTypes.videoPreviewCf;
};

export type TMediaCFVideo = {
	type: MediaTypes.videoCf;
	previewLinks: TMediaImage[];
	reference: string;
};

export type TMediaDefaultVideo = {
	type: MediaTypes.videoDefault;
	previewLinks: TMediaImage[];
	reference: string;
};

export type TMediaImage =
	| TMediaCFPublicImage
	| TMediaDefaultImage
	| TMediaCFImage
	| TMediaCFVideoPreview; // union for all IMAGE types

export type TMediaVideo = TMediaDefaultVideo | TMediaCFVideo; // union for all VIDEO types
export type TMedia = TMediaImage | TMediaVideo; // union for all MEDIA types
